import Button from "./components/_button";
import { scrollToElement } from "./components/_scrollto";



class Main {
  button: Button;

  constructor() {
    this.button = new Button();
    this.button.state('.js-collapse');
    this.button.state('.js-toc');
    this.generateTitles();
    this.anchorsScroll();
    this.activeScroll();
    this.hideScroll();
    this.showMore();
  }

  activeScroll() {

    let menuSection = document.querySelectorAll('.st__list li a') as any;
    menuSection.forEach((link) => {
      link.addEventListener('click', () => {
        setTimeout(() => {
          menuSection.forEach(j => j.classList.remove('active'))
          link.classList.add('active')
        }, 300)
      })
    })

    document.onscroll = (() => {
      let mainSection = document.querySelectorAll('.st__table h1, .st__table h2, .st__table h3, .st__table h4, .st__table h5, .st__table h6') as any;

      mainSection.forEach((v, i) => {
        let rect = v.getBoundingClientRect().y
        if (rect < window.innerHeight - 500) {
          menuSection.forEach(v => v.classList.remove('active'))
          menuSection[i].classList.add('active')
        }
      })
    })
  }

  hideScroll() {
    window.addEventListener('scroll', () => {
      if(window.scrollY > 500) {
        document.querySelector('.scroll__btn').classList.remove('opacity-0', 'pointer-events-none');
      } else {
        document.querySelector('.scroll__btn').classList.add('opacity-0', 'pointer-events-none');
      }
    })
  }

  anchorsScroll() {
    const anchors = document.querySelectorAll('.js-anchor');
    anchors.forEach(anchor => {
      anchor.addEventListener('click', (e) => {
        const href = (anchor as HTMLLinkElement).getAttribute('href');
        const element = document.querySelector(href);
        if (element) {
          e.preventDefault();
          // this.body.classList.remove('mso');
          scrollToElement(href);
        }
      })
  });
  }

  generateTitles() {

    let stickyModules = [].slice.call(document.querySelectorAll(".st"))

      if(!stickyModules) return;
      var level = 0;

    stickyModules.forEach((table, i, a) => {
      var toc = "";

      table.querySelector('.st__table').innerHTML = table.querySelector('.st__table').innerHTML.replace(
        /<h([\d])>([^<]+)<\/h([\d])>/gi,

        function (str, openLevel, titleText, closeLevel) {
          if (openLevel != closeLevel) {
            return str;
          }

          level = parseInt(openLevel);

          var anchor = titleText.replace(/ /g, "_");
          anchor = anchor.replace('?', '');

          toc += `<li><a class="js-anchor block font-m relative" href="#${anchor}">${titleText}</a></li>`;

          return `<h${openLevel} id="${anchor}">${titleText}</h${closeLevel}>`;
        }

      )

      table.querySelector(".st__list").innerHTML += toc;

      if (level) {
        toc += (new Array(level + 1)).join("</ul>");
      }
    });
  }

  showMore() {
    document.querySelectorAll('.js-showmore').forEach(btn => {
      btn.addEventListener('click', (e) => {
        (e.target as HTMLElement).classList.add('hidden');
        document.querySelector('.more-content').classList.add('block');
        document.querySelector('.more-content').classList.remove('hidden');
      })
    })
  }
}

new Main;